/* eslint-disable react/react-in-jsx-scope */
import { useContext } from 'react';
// import { UserContext } from '../contexts/testContext';
import { useUserContext, useUserDispatch } from '../contexts/testContext';


const Test2 = ({ children }) => {
    // const userCon = useContext(UserContext);
    const userCon = useUserContext();

    console.log(userCon);

  return (
    <section className="section">
      <p>Test2 isLogin: {userCon.isLogin}</p>
      <div>
        User: {userCon.user.email}
        {children}
      </div>
    </section>
  )
}

export default Test2